import React from "react";
import { IconT } from "types/utils";

const SparkleIcon = ({ height = "19", width = "19", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="m12 3 2 5 5 2-5 2-2 5-2-5-5-2 5-2 2-5Z"
        stroke={fill}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default SparkleIcon;
